module.exports = __webpack_public_path__ + "img/ru-ba.d409a794.svg";